import TimePickerV1 from "../../../../components/form_builder/elements/time_picker/TimePickerV1.vue";
import { validateRequired } from "../../../../helpers/validation";

export default {
  componentName: "fb-time-picker-v1",
  component: TimePickerV1,
  defaultAttrs: {
    properties: {
      label: "Label",
      description: "",
      value: "",
      required: false,
      hidden: false,
      readonly: false,
      style: {},
      eFormEditable: true
    }
  },
  gridAttrs: {
    type: "template",
    width: 80,
    template: ({ value }) => value
  },
  getValueReport: value => {
    return value;
  },
  validate: ({ value, properties }) => {
    const errors = [];
    if (properties.required && !validateRequired(value))
      errors.push("This field is required");
    return errors;
  }
};
